var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52539 4C3.52539 3.44772 3.97311 3 4.52539 3H20.5254C21.0777 3 21.5254 3.44772 21.5254 4C21.5254 4.55228 21.0777 5 20.5254 5H4.52539C3.97311 5 3.52539 4.55228 3.52539 4ZM8.2325 8.29289C8.62302 8.68342 8.62302 9.31658 8.2325 9.70711L5.9396 12L8.2325 14.2929C8.62302 14.6834 8.62302 15.3166 8.2325 15.7071C7.84197 16.0976 7.20881 16.0976 6.81828 15.7071L3.81828 12.7071C3.42776 12.3166 3.42776 11.6834 3.81828 11.2929L6.81828 8.29289C7.20881 7.90237 7.84197 7.90237 8.2325 8.29289ZM9.34358 12C9.34358 11.4477 9.79129 11 10.3436 11H20.5254C21.0777 11 21.5254 11.4477 21.5254 12C21.5254 12.5523 21.0777 13 20.5254 13H10.3436C9.79129 13 9.34358 12.5523 9.34358 12ZM3.52541 20C3.52541 19.4477 3.97312 19 4.52541 19H20.5254C21.0777 19 21.5254 19.4477 21.5254 20C21.5254 20.5523 21.0777 21 20.5254 21H4.52541C3.97312 21 3.52541 20.5523 3.52541 20Z",
    fill: "#A4728C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.15e20f7373f3ff0310c67d55c98059af.svg";
export { ForwardRef as ReactComponent };